import { environment } from '@src/environments/environment';

export const logger = (message: any, ...optionalParams: any[]) => {
  if (!!environment.featureFlags?.loggerEnabled) {
    // eslint-disable-next-line
    console.debug(message, ...optionalParams);
  }
};
